import api from '../services/authService';

export interface Integration {
  id: string;
  provider: 'github' | 'notion' | 'asana' | 'jira';
  workspaceId: string | null;
  baseUrl: string | null;
  createdAt: string;
  isConnected: boolean;
}

export const integrationsApi = {
  getIntegrations: async () => {
    const response = await api.get('/integrations');
    return response.data;
  },
  
  getConnectUrl: async (provider: string) => {
    const response = await api.get(`/integrations/${provider}/connect`);
    return response.data;
  },

  handleCallback: async (provider: string, code: string) => {
    const response = await api.post(`/integrations/${provider}/callback`, { code });
    return response.data;
  },

  syncToProvider: async (provider: string, projectId: string, payload: any) => {
    const response = await api.post(`/integrations/${provider}/sync/${projectId}`, payload);
    return response.data;
  },

  getSyncLogs: async (projectId: string) => {
    const response = await api.get(`/integrations/project/${projectId}/logs`);
    return response.data;
  },

  saveProjectConfig: async (projectId: string, provider: string, config: any) => {
    const response = await api.post(`/integrations/project/${projectId}/config/${provider}`, { config });
    return response.data;
  },

  getProjectConfig: async (projectId: string, provider: string) => {
    const response = await api.get(`/integrations/project/${projectId}/config/${provider}`);
    return response.data;
  },
  
  disconnect: async (provider: string) => {
    const response = await api.delete(`/integrations/${provider}`);
    return response.data;
  }
};
